export const REQUEST_LEADER_BOARD_FETCH_USER =
  "REQUEST_LEADER_BOARD_FETCH_USER";
export const FETCH_LEADER_BOARD_USER_SUCCESS =
  "FETCH_LEADER_BOARD_USER_SUCCESS";
export const FETCH_LEADER_BOARD_USER_FAILURE =
  "FETCH_LEADER_BOARD_USER_FAILURE";

export const CLEAR_FETCH_LEADER_BOARD_USER_STATES =
  "CLEAR_FETCH_LEADER_BOARD_USER_STATES";
